module.exports = __webpack_public_path__ + "img/Anhänger_Stromerzeuger.f777a20d.svg";